import makeStyles from '@mui/styles/makeStyles';
import { Typography } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import { ErrorMessage } from './ErrorMessage';
import errorImg from '@assets/icons/error.svg';

export const useStyles = makeStyles<Theme>({
  wrapper: { padding: 30, textAlign: 'center' },
  image: { height: 60 },
});

export interface ErrorContentProps {
  error: Error;
}

export const ErrorContent = (props: ErrorContentProps) => {
  const { wrapper, image } = useStyles();

  return (
    <div className={wrapper}>
      <img className={image} src={errorImg} alt='Empty' />
      <Typography color='inherit' align='center' component='div'>
        <Typography color='inherit' variant='h5' gutterBottom>
          Error
        </Typography>
        <Typography color='inherit' component='div'>
          <ErrorMessage error={props.error} showStack={process.env.NODE_ENV === 'development'} />
        </Typography>
      </Typography>
    </div>
  );
};
